import { Component, Output, EventEmitter, ViewChild } from "@angular/core";
import { environment } from "../../../environments/environment";
import { MzBaseModal } from "ng2-materialize";
import { Utils } from "../../utils/utils";
import { PlanningPokerService } from "../../services/planning-poker/planning-poker.service";
import { RiskIndicator } from "../../interfaces/riskIndicator";
import { DeleteItemConfirmationDialogComponent } from "../delete-item-confirmation-dialog/delete-item-confirmation-dialog.component";
import { Subject } from "rxjs";

@Component({
  selector: "app-retrospective-wizard-3-vote",
  templateUrl: "./retrospective-wizard-3-vote.component.html",
  styleUrls: ["./retrospective-wizard-3-vote.component.scss"],
})
export class RetrospectiveWizardVoteComponent extends MzBaseModal {
  readonly env: any = environment;
  readonly utils: any = Utils;

  riskIndicator: RiskIndicator;
  lastRiskIndicator: boolean;
  loading: boolean;
  planningPokerLink: string;
  current: number;
  total: number;
  resultSubject: Subject<boolean>;

  @Output() loadingFinished: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild("AbortConfirmationModal")
  abortConfirmationModal: DeleteItemConfirmationDialogComponent;

  constructor(public planningPokerService: PlanningPokerService) {
    super();
  }

  ngAfterViewInit() {}

  async show(
    resume: boolean,
    riskIndicator: RiskIndicator,
    current: number,
    total: number
  ): Promise<boolean> {
    this.resultSubject = new Subject<boolean>();
    this.riskIndicator = riskIndicator;
    this.current = current;
    this.total = total;
    this.lastRiskIndicator = current === total;
    if (
      !resume ||
      this.planningPokerService.currentFeatureId !== riskIndicator._id
    ) {
      await this.planningPokerService.startEstimation(riskIndicator._id);
    }
    this.loadingFinished.emit();
    this.modalComponent.open();
    return await this.resultSubject.first().toPromise();
  }

  async closeVoting() {
    this.loading = true;
    if (!this.planningPokerService.planningClosed) {
      await this.planningPokerService.stopEstimation(this.riskIndicator._id);
    }
    this.loading = false;
  }

  async abort() {
    this.modalComponent.close();
    await this.modalComponent.onClose
      .map((_) => true)
      .first()
      .toPromise();
    let result = await this.abortConfirmationModal.getResultAsync();
    if (result) {
      await this.closeVoting();
      this.resultSubject.next(false);
    } else {
      this.modalComponent.open();
    }
  }

  async confirm() {
    this.modalComponent.close();
    await this.modalComponent.onClose
      .map((_) => true)
      .first()
      .toPromise();
    this.resultSubject.next(true);
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/retrospective-wizard-3-vote/retrospective-wizard-3-vote.component.ts